import { CSSProperties } from 'react';
import styled from 'styled-components';

import { BodilColor } from '~src/branding';

import { headingStyle } from '../Typography';

export const SwipeButtonTrack = styled.div<{ color?: string; disabled?: boolean; style?: CSSProperties }>(
  ({ color, disabled, style }) => {
    return {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      height: '54px',
      width: '279px',
      backgroundColor: disabled ? BodilColor.greyscale[40] : color,
      borderRadius: '100px',
      padding: '4px',
      margin: '16px',
      ...style,
    };
  }
);

export const SwipeButtonMovableCircle = styled.div<{
  positionX?: number;
  disabled?: boolean;
  trackWidth?: number;
}>(({ positionX, disabled, trackWidth }) => {
  const position = positionX ? positionX - 100 : 0;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '46px',
    width: '46px',
    borderRadius: '50%',
    backgroundColor: 'white',
    transform: `translate(${position}px,0px)`,
    opacity: `${((trackWidth ?? 0) - (positionX ?? 0)) / (trackWidth ?? 0)}`,
    cursor: disabled ? 'inherit' : 'pointer',
  };
});

export const SwipeButtonText = styled.div({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
  ...headingStyle(2),
  color: 'white',
  whiteSpace: 'nowrap',
  userSelect: 'none',
});
